import React, { useCallback, useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import { SuccessfullyModal } from '../../components/Modals/Modals';
import { getApi, putApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

const CreatePassword = () => {
  const navigate = useNavigate()
  const { id } = useParams();

  const [show, setShow] = useState(false)

  const [uniqueId, setUniqueId] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    gender: '',
    role: '',
    subcategoryId: '',
    description: '',
    status: "",
  });

  const [imagePreviews, setImagePreviews] = useState({
    addressProof: '',
    aadharCardFront: '',
    aadharCardBack: '',
    panCardLicensePassport: '',
    policeVerification: '',
    image: "",
  });




  const handleUpdate = async () => {
    const payload = {
      uniqueId: uniqueId,
      password: password,
    };

    await putApi(endPoints.updateidpassword(id), payload, {
      setLoading,
      errorMsg: 'Failed to Created U-ID/Password!',
    });
    setShow(true);

    setTimeout(() => {
      setShow(false);
      navigate('/staff-management/registered');  
    }, 2000);
  };



  const fetchStaffData = useCallback(async () => {
    await getApi(endPoints.getStaffbyid(id), {
      setResponse: (response) => {
        const data = response?.data || {};
        setFormData({
          firstName: data.firstName || '',
          lastName: data.lastName || '',
          phone: data.phone || '',
          email: data.email || '',
          gender: data.gender || '',
          role: data.role || [],
          subcategoryId: data.subcategoryId || [],
          description: data.description || '',
          status: data.status || '',
        });
        setImagePreviews({
          addressProof: data.addressProof || '',
          aadharCardFront: data.aadharCardFront || '',
          aadharCardBack: data.aadharCardBack || '',
          panCardLicensePassport: data.panCardLicensePassport || '',
          policeVerification: data.policeVerification || '',
          image: data.image || '',
        });
      },
      setLoading,
      errorMsg: 'Failed to fetch data!',
    });
  }, [id]);



  useEffect(() => {
    fetchStaffData();
  }, [fetchStaffData]);


  return (
    <>
      <SuccessfullyModal
        show={show}
        handleClose={() => setShow(false)}
        text={"Successfully Created U-ID/Password"}
      />
      <div className={addjob.jobmanagementCotainer}>
        <div className={addjob.jobtoppart}>
          <div className={addjob.pagetitle}>
            <h6>Create U-Id / Password</h6>
          </div>
        </div>
        <div className={addjob.addjobcontainer}>
          <div className={addjob.addusercontainer}>
            <div className={addjob.adduserleftcontainer}>
              <h6>Staff Details</h6>
              <div className={addjob.adduserleftdetails}>
                <div className={addjob.adduserleftprofileimage}>
                  <img src={imagePreviews.image} alt={formData.firstName} />
                </div>
                <div className={addjob.adduserleftuserdetails}>
                  <div className={addjob.adduserleftuser}>
                    <p>Name</p>
                    <span>:</span>
                    <p>{formData.firstName} {formData.lastName}</p>
                  </div>
                  <div className={addjob.adduserleftuser}>
                    <p>Email</p>
                    <span>:</span>
                    <p>{formData.email}</p>
                  </div>
                  <div className={addjob.adduserleftuser}>
                    <p>Number</p>
                    <span>:</span>
                    <p>+91{formData.phone}</p>
                  </div>
                  {/* <div className={addjob.adduserleftuser}>
                    <p>Role</p>
                    <span>:</span>
                    <ul>
                      {
                        formData?.role?.length === 0 ?
                          <option value="">No Role</option>
                          :
                          formData?.role?.map((cat) => (
                            <li>{cat}</li>
                          ))}
                    </ul>
                  </div> */}
                  <div className={addjob.adduserleftuser}>
                    <p>Job Role</p>
                    <span>:</span>
                    <ul>
                      {
                        formData?.subcategoryId?.length === 0 ?
                          <option value="">No Role</option>
                          :
                          formData?.subcategoryId?.map((cat) => (
                            <li>{cat?.name}</li>
                          ))}
                    </ul>
                  </div>
                  <div className={addjob.adduserleftuser}>
                    <p>Gender</p>
                    <span>:</span>
                    <p>{formData.gender ? formData.gender : "N/A"}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={addjob.adduserrightcontainer}>
              <h6>Documents</h6>
              <div className={addjob.adduserleftuserdetails}>
                <div className={addjob.adduserrightdocumentimage}>
                  <div className={addjob.adduserrightdocument}>
                    <img src={imagePreviews.addressProof} alt="no img" />
                  </div>
                  <div className={addjob.adduserrightdocument}>
                    <img src={imagePreviews.aadharCardFront} alt="no img" />
                  </div>
                  <div className={addjob.adduserrightdocument}>
                    <img src={imagePreviews.aadharCardBack} alt="no img" />
                  </div>
                  <div className={addjob.adduserrightdocument}>
                    <img src={imagePreviews.panCardLicensePassport} alt="no img" />
                  </div>
                </div>
                <div className={addjob.adduserleftuserdetails}>
                  <div className={addjob.adduserleftuser}>
                    <p>Description</p>
                    <span>:</span>
                    <h5>{formData.description ? formData.description : "N/A"}</h5>
                  </div>
                  <div className={addjob.adduserleftuser}>
                    <p>Status</p>
                    <span>:</span>
                    <p>{formData.status}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={addjob.addusercontainer}>
            <div className={addjob.adduserbottominputes}>
              <div className={addjob.addjobinputs} >
                <label htmlFor="">Create Unique ID</label>
                <input
                  type="text"
                  placeholder='Set Unique Id'
                  value={uniqueId}
                  onChange={(e) => setUniqueId(e.target.value)}
                  style={{ width: '95%' }}
                />
              </div>
            </div>
            <div className={addjob.adduserbottominputes}>
              <div className={addjob.addjobinputs} >
                <label htmlFor="">Password</label>
                <input
                  type="text"
                  placeholder='Set password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ width: '95%' }}
                />
              </div>
            </div>
          </div>


          <div className={addjob.addjobbutton}>
            <div className={addjob.rightbuttons}>
              <button onClick={() => navigate(-1)}>Cancel</button>
            </div>
            <div className={addjob.rightbuttons}>
              <button
                onClick={handleUpdate}
                style={{ background: '#F05423' }}
                disabled={loading}
              >
                {loading ? "Creating..." : "Create"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HOC(CreatePassword)
